import * as React from 'react'
import { withStyles } from '@material-ui/core'
import * as core from '@material-ui/core'
import { ControlProps } from '@pulseops/common'

type InputProps = ControlProps<string | null> & {
  label?: string
  value?: string | null
  type?: string
  placeholder?: string
  maxLength?: number
  disabled?: boolean
  isDigit?: boolean
  controlStyle?: React.CSSProperties
}

export const BorderInput = (props: InputProps) => {
  return (
    <core.FormControl style={props.controlStyle} error={!!props.errorMessage}>
      <SC.TextField
        label={props.label}
        placeholder={props.placeholder ?? 'Nhập...'}
        variant="outlined"
        value={props.value}
        onChange={(event) => {
          let val = event.target.value || ''
          if (props.isDigit) {
            val = val.replace(/[^0-9]/g, '')
          }
          props.onChange && props.onChange(val)
        }}
        type={props.type || 'text'}
        inputProps={{
          ...(props.maxLength != null ? { maxLength: props.maxLength } : {})
        }}
        disabled={props.disabled}
      />
      {props.errorMessage ? <core.FormHelperText>{props.errorMessage}</core.FormHelperText> : null}
    </core.FormControl>
  )
}

const SC = {
  TextField: withStyles({
    root: {
      width: '100%',
      minWidth: '84px',
      '& .MuiOutlinedInput-root': {
        background: 'white',
        borderRadius: 8,
        height: 46,
        padding: '5px 10px',
        '& fieldset': {
          borderColor: '#D3DCE6'
        }
      },
      '& .MuiOutlinedInput-input': {
        fontSize: 24,
        padding: 0
      }
    }
  })(core.TextField)
}
